/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// Class that represents the data of this store

class EnvironmentSettingsReducerData {
  catalogInfoPath: string = '';
  resourcesPath: string = '';
  catalogFileName: string = '';
}

// Initial State

const initialState : EnvironmentSettingsReducerData = {
  catalogInfoPath: '',
  resourcesPath: '',
  catalogFileName: '',
};

// Store definition

export const EnvironmentSettingsReducer = createSlice({

  name: 'EnvironmentSettingsReducer',

  initialState,

  reducers: {
    setConfiguration: (state, action : PayloadAction<{
      CATALOG_INFO_PATH : string,
      RESOURCES_PATH : string,
      CATALOG_FILE_NAME : string
    }>) => {
      state.catalogInfoPath = action.payload.CATALOG_INFO_PATH;
      state.resourcesPath = action.payload.RESOURCES_PATH;
      state.catalogFileName = action.payload.CATALOG_FILE_NAME;
    },
  },
});
